import { optionStatusBin } from '../../../pages/daf/Adm/Dominios/utils/optionStatusBin';
import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemDominiosTiposExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => {
      return {
        id: item.id,
        dominio: item.dominio.id,
        status: optionStatusBin[item.status]?.label,
        ordem: item.ordem,
        dominioTipo: item.dominioTipo,
        descricao: item.descricao,
        cor: item.cor.codigoHexadecimal,
        corText: item.corText === 2 ? 'Branco' : 'Preto',
        subtipos: item.subtipos,
        observacoes: item.observacoes,
        usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
        dataRegistro: item.dataRegistro,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
        nEdicoes: item.nEdicoes || 0,
      };
    });

    const mainSheet: ExportSheet = {
      name: 'Listagem de Tipos de Domínios',
      columns: {
        id: 'ID',
        status: 'Status do Tipo de Domínio',
        ordem: 'Ordem',
        dominioTipo: 'Nome do Tipo de Domínio',
        descricao: 'Descrição',
        cor: 'Cor do Background',
        corText: 'Cor do Texto',
        subtipos: 'Subtipos de Domínios',
        observacoes: 'Observações',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        dataUltimaAtualizacao: 'Última Atualização',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
